import axios from 'axios'
import { API_ROOT, INTERCOM_KEY, bugsnagClient } from '../constants/AppConstants'
import { setGlobalCSRF } from '../utils/Util'
import LogRocket from 'logrocket'
import BookingStepsConfig from '../configs/BookingStepsConfig'
import { BOOKING_FLOW_CONFIGS } from '../constants/AppConstants'
axios.defaults.withCredentials = true

class UserService {
  async login(credentials) {
    const response = await axios.post(API_ROOT + 'auth/signin', credentials)
    BookingStepsConfig.setActiveConfig(BOOKING_FLOW_CONFIGS.GARAGE_FLOW)
    setGlobalCSRF(response)
    return response
  }

  async logout() {
    await axios.get(API_ROOT + 'auth/signout')
    BookingStepsConfig.setActiveConfig(BOOKING_FLOW_CONFIGS.DEFAULT_FLOW)
    return
  }

  async requestPasswordReset(emailId) {
    const response = await axios.get(API_ROOT + 'auth/forgotpassword/' + emailId)
    return response.data
  }

  async resetPassword(resetData) {
    const response = await axios.post(API_ROOT + 'auth/resetpassword/', resetData)
    return response.data
  }

  async signupUser(userInfo) {
    const response = await axios.post(API_ROOT + 'auth/signup', userInfo)
    BookingStepsConfig.setActiveConfig(BOOKING_FLOW_CONFIGS.GARAGE_FLOW)
    setGlobalCSRF(response)
    return response.data
  }

  async isEmailExist(emailId) {
    let emailExists = false
    try {
      await axios.get(API_ROOT + 'anonymous/emailExist/' + emailId)
      //if it reached here, then server returned status 200 and emailexists is false
    } catch (err) {
      //we care only about 409 error
      if (err.response && err.response.status === 409) {
        emailExists = true
      }
    }
    return emailExists
  }

  async updateUser(userId, userInfo) {
    const response = await axios.put(API_ROOT + 'users/' + userId, userInfo)
    return response.data
  }

  async loginUsingCookie() {
    try {
      const response = await axios.put(API_ROOT + 'auth/cookielogin')
      BookingStepsConfig.setActiveConfig(BOOKING_FLOW_CONFIGS.GARAGE_FLOW)
      return response.data
    } catch (err) {
      console.log('no valid session cookie found.')
      return null
    }
  }

  async getCsrfToken() {
    const response = await axios.get(API_ROOT + 'auth/csrftoken')
    setGlobalCSRF(response)
    return response.data
  }

  identifyUser(userDetails) {
    LogRocket.identify(userDetails._id, {
      name: userDetails.firstName + ' ' + userDetails.lastName,
      email: userDetails.email
    })

    bugsnagClient.user = {
      id: userDetails._id,
      name: userDetails.firstName + ' ' + userDetails.lastName,
      email: userDetails.email
    }

    window.Intercom('boot', {
      app_id: INTERCOM_KEY,
      name: userDetails.firstName + ' ' + userDetails.lastName,
      email: userDetails.email
    })

    this.notifyDrip(userDetails)
  }

  notifyDrip(userDetails, addTags, removeTags) {
    /* if (window && window._dcq) {
      let identifyParams = {
        email: userDetails.email,
        custom_fields: {
          firstName: userDetails.firstName,
          lastName: userDetails.lastName
        },
        success: function(response) {
          console.log('User successfully identified')
        },
        failure: function(error) {
          console.log('Error identifying user ' + error)
        }
      }
      if (addTags) {
        identifyParams.tags = addTags
      }
      if (removeTags) {
        identifyParams.remove_tags = removeTags
      }

      window._dcq.push(['identify', identifyParams])
    } */
  }
}

export default new UserService()



// WEBPACK FOOTER //
// ./src/services/UserService.js